exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".faq-question-arrow,.faq-question-arrow-down{display:inline-block;position:relative;float:right;margin-top:3px;margin-right:20px;width:18px;height:11px;background:url(" + require("../Arrow/arrow.svg") + ") no-repeat;transition-duration:.3s}.faq-question-arrow-down{transform:rotate(180deg)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Arrow/Arrow.scss
 ** module id = 1188
 ** module chunks = 0
 **/